/* On this page pill (snippets/pb-jump), product pages.
   - Sections are read from the page: each entry names its targets in order (element ids, theme section keys, a CSS
     fallback); the first one present wins. Only entries found are listed, in the page's top-to-bottom order.
   - Shows once the add-to-cart button has scrolled above the top bar; hidden at the top. Needs two or more entries.
   - The label follows the section in view. Picking an entry smooth-scrolls it to just under the top bar.
   - The list closes on a tap outside, Escape, a scroll, a width change; it and the bar's panels close each other. */
(function () {
  if (window.__pbJump) return;
  var D = document, H = D.documentElement;
  var wrap = D.getElementById('pbj'), btn = D.getElementById('pbj-btn'), pnl = D.getElementById('pbj-pnl');
  var lst = D.getElementById('pbj-lst'), lab = D.getElementById('pbj-lab'), szr = D.getElementById('pbj-szr');
  var bar = D.getElementById('pbt-bar');
  if (!wrap || !btn || !pnl || !lst || !bar) return;
  window.__pbJump = 1;

  var DEF = [
    { k: 'buy', t: 'Buy', ids: ['main'] },
    { k: 'story', t: 'Story', ids: ['story', 'shapeshift', 'views', 'modes', 'product-story'] },
    { k: 'features', t: 'Features', ids: ['features', 'pockets', 'comfort', 'colours', 'beats-a'] },
    { k: 'specs', t: 'Specs', ids: ['specs'], sel: '.pb-bss .pb-bs__specs' },
    { k: 'in-box', t: 'In the box', ids: ['in-box'], sel: '.pb-bss .pb-bs__wyg' },
    { k: 'reviews', t: 'Reviews', ids: ['product-reviews'] }
  ];
  function shown(el) { return !!(el && el.getClientRects().length); }
  function find(id) {
    var t = D.getElementById(id);
    if (!t || t === D.body) t = D.querySelector('[id^="shopify-section-"][id$="__' + id + '"]');
    return shown(t) ? t : null;
  }
  var items = [], act = null, pref = null, jumping = false, on = false, open = false, y0 = 0, w0 = 0, atc = null;

  function build() {
    var got = [];
    DEF.forEach(function (d) {
      var el = null;
      for (var i = 0; i < d.ids.length && !el; i++) el = find(d.ids[i]);
      if (!el && d.sel) { var s = D.querySelector(d.sel); if (shown(s)) el = s; }
      if (el && !got.some(function (g) { return g.el === el; })) got.push({ k: d.k, t: d.t, el: el });
    });
    got.sort(function (a, b) { return (a.el.compareDocumentPosition(b.el) & 4) ? -1 : 1; });
    var key = got.map(function (g) { return g.k; }).join('|');
    if (key === lst.getAttribute('data-k')) { items = got; return; }
    items = got; lst.setAttribute('data-k', key);
    lst.textContent = ''; szr.textContent = '';
    got.forEach(function (g) {
      var li = D.createElement('li'), a = D.createElement('a');
      a.href = '#' + (g.el.id || ''); a.textContent = g.t; a.setAttribute('data-pbj', g.k);
      li.appendChild(a); lst.appendChild(li);
      var sz = D.createElement('span'); sz.textContent = g.t; szr.appendChild(sz);
    });
    act = null; track();
  }

  function barBottom() { var r = bar.getBoundingClientRect(); return Math.max(0, r.bottom); }
  function paint(k) {
    act = k;
    var it = null; items.forEach(function (g) { if (g.k === k) it = g; });
    if (it && lab.textContent !== it.t) lab.textContent = it.t;
    [].forEach.call(lst.querySelectorAll('a'), function (a) {
      if (a.getAttribute('data-pbj') === k) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  var rq = 0;
  function track() {
    rq = 0;
    if (!items.length) return;
    var bb = barBottom();
    /* shown once the add-to-cart button is above the bar */
    if (!atc || !atc.isConnected) atc = D.querySelector('[id^="x-atc-button-"]') || D.querySelector('[id^="ProductInfo-"]');
    var past = atc ? atc.getBoundingClientRect().bottom < bb : window.scrollY > window.innerHeight;
    var want = past && items.length > 1;
    if (want !== on) {
      on = want; wrap.classList.toggle('is-on', on); wrap.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      if (!on) close(false);
    }
    /* the section in view: the last one starting above a line just under the pill; level starts keep the earlier */
    var probe = bb + 110, k = items[0].k, top = -Infinity, tops = {};
    items.forEach(function (g) {
      var t = tops[g.k] = g.el.getBoundingClientRect().top;
      if (t <= probe && t > top + 40) { k = g.k; top = t; }
    });
    /* a picked entry keeps the label while it starts level with the winner (Specs and In the box side by side) */
    if (pref && pref !== k && tops[pref] != null && tops[pref] <= probe && Math.abs(tops[pref] - top) <= 40) k = pref;
    else if (pref !== k && !jumping) pref = null;
    if (jumping && pref) k = pref;
    if (k !== act) paint(k);
  }
  function soon() { if (!rq) rq = requestAnimationFrame(track); }

  function place() {
    var b = btn.getBoundingClientRect(), vw = H.clientWidth || window.innerWidth;
    var top = Math.round(b.bottom + 8);
    pnl.style.setProperty('--pbt-pt', top + 'px');
    pnl.style.top = top + 'px'; pnl.style.right = ''; pnl.style.bottom = '';
    var m = vw < 750 ? 10 : 14, w = pnl.offsetWidth;
    var left = Math.max(m, Math.min(b.left + b.width / 2 - w / 2, vw - w - m));
    pnl.style.left = Math.round(left) + 'px';
  }
  function setOpen(v, back) {
    if (v === open) return;
    open = v;
    if (v) {
      if (window.pbTopbarClose) try { window.pbTopbarClose(); } catch (e) {}
      y0 = window.scrollY; w0 = window.innerWidth;
      place();
    }
    pnl.classList.toggle('is-on', v);
    H.classList.toggle('pbj-open', v);
    btn.setAttribute('aria-expanded', v ? 'true' : 'false');
    if (v) setTimeout(function () {
      if (!open) return;
      var f = lst.querySelector('a[aria-current]') || lst.querySelector('a');
      if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
    }, 60);
    else if (back) try { btn.focus({ preventScroll: true }); } catch (e) {}
  }
  function close(back) { setOpen(false, back); }

  function go(g) {
    var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function y() { return Math.max(0, Math.round(g.el.getBoundingClientRect().top + window.scrollY - barBottom())); }
    paint(g.k); pref = g.k; jumping = true;
    try { window.scrollTo({ top: y(), behavior: rm ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y()); }
    /* late images can move the target while the page scrolls: settle once it stops */
    var last = -1, n = 0;
    (function settle() {
      if (++n > 40) { jumping = false; return; }
      var s = window.scrollY;
      if (Math.abs(s - last) > 1) { last = s; setTimeout(settle, 120); return; }
      var d = g.el.getBoundingClientRect().top - barBottom();
      if (Math.abs(d) > 6) window.scrollTo(0, y());
      setTimeout(function () { jumping = false; track(); }, 150);
    })();
  }

  btn.addEventListener('click', function (e) { e.preventDefault(); setOpen(!open, false); });
  lst.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-pbj]'); if (!a) return;
    e.preventDefault();
    var k = a.getAttribute('data-pbj'), g = null; items.forEach(function (x) { if (x.k === k) g = x; });
    close(false);
    if (g) go(g);
  });
  D.addEventListener('pointerdown', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (open && !t.closest('#pbj-pnl') && !t.closest('#pbj-btn')) close(false);
  }, { capture: true, passive: true });
  /* the bar's own buttons open its panels: this list steps aside */
  D.addEventListener('click', function (e) {
    var t = e.target; if (open && t && t.closest && t.closest('#pbt-bar [data-pbt-open], #pbt-cart')) close(false);
  }, true);
  D.addEventListener('keydown', function (e) {
    if (open && e.key === 'Escape') { e.stopPropagation(); close(true); }
  }, true);
  window.addEventListener('scroll', function () {
    if (open && Math.abs(window.scrollY - y0) > 6) close(false);
    soon();
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (open && Math.abs(window.innerWidth - w0) > 1) close(false); else if (open) place();
    soon();
  }, { passive: true });
  window.addEventListener('pageshow', function () { close(false); soon(); });
  window.addEventListener('pagehide', function () { close(false); });

  build();
  window.addEventListener('load', function () { build(); track(); });
  setTimeout(build, 2500);
  track();
})();
